import "./Promise.css";

function Promise() {
  return (
    <section className="promise">
      <div className="container promise-wrap">

        <p className="promise-label">OUR PROMISE</p>

        <h2 className="promise-text">
          We don’t just advise — we partner with you to create meaningful,
          measurable, and lasting impact.
        </h2>

      </div>
    </section>
  );
}

export default Promise;